import { useRegisterSW } from 'virtual:pwa-register/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from './ui/button'
import { RefreshCw, X } from 'lucide-react'

export function PWAUpdatePrompt() {
  const { t } = useTranslation()
  const [hidePrompt, setHidePrompt] = useState(false)

  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW()

  const close = () => {
    setOfflineReady(false)
    setNeedRefresh(false)
    setHidePrompt(true)
  }

  if (hidePrompt) return null

  return (
    <>
      {(offlineReady || needRefresh) && (
        <div className="fixed bottom-4 left-4 right-4 bg-card text-card-foreground border border-border p-4 rounded-lg shadow-lg z-50 md:left-auto md:right-4 md:max-w-sm">
          <div className="flex items-start gap-3">
            <RefreshCw className="h-5 w-5 flex-shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              {offlineReady ? (
                <>
                  <p className="text-sm font-medium">{t('pwa.update.offlineReady.title')}</p>
                  <p className="text-xs text-muted-foreground">
                    {t('pwa.update.offlineReady.description')}
                  </p>
                </>
              ) : (
                <>
                  <p className="text-sm font-medium">{t('pwa.update.newVersion.title')}</p>
                  <p className="text-xs text-muted-foreground">
                    {t('pwa.update.newVersion.description')}
                  </p>
                </>
              )}
            </div>
            <Button
              size="sm"
              variant="ghost"
              onClick={close}
              className="h-6 w-6 p-0 hover:bg-muted"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
          {needRefresh && (
            <div className="mt-3 flex gap-2">
              <Button
                size="sm"
                onClick={() => updateServiceWorker(true)}
                className="text-xs"
              >
                {t('pwa.update.reload')}
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={close}
                className="text-xs"
              >
                {t('pwa.update.later')}
              </Button>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default PWAUpdatePrompt
